'use client';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import GridTable from '../../shared/components/grid/GridTable';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { useEffect, useState } from 'react';
import { CommitHandler } from '../../features/screens_access/commitHandler';
import ScreenAccessColumnConfig from '../../features/screens_access/components/ScreenAccessColumnConfig';
import { t } from '../../i18next';
import HeaderScreenList from '../../features/attributes_access/components/HeaderScreenList';
import { getHeaderScreenDetails } from '../../features/getHeaderScreenDetails';
import { useConfigContext } from '../../shared/context/ConfigContext';

const ScreensAccessPage = () => {
  const { loading, error, screenTables } = useFetchScreenDetails('screens_access');

  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <ScreensAccess tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default ScreensAccessPage;

const ScreensAccess = ({ tableRes }) => {
  const { updateCustomConfig } = useColumnContextAPI();
  const [screenOptions, setScreenOptions] = useState([]);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const { configSchema } = useConfigContext();

  useEffect(() => {
    const fetchScreens = async () => {
      const screensDetails = await getHeaderScreenDetails(tableRes.id, configSchema);
      const screenList = screensDetails[`${configSchema}_mbd_screens`].map(
        ({ id: value, screen_display_name_en: label }) => ({ value, label }),
      );
      setSelectedScreen(screenList[0]?.value);
      setScreenOptions(screenList);
    };
    fetchScreens();
  }, []);

  useEffect(() => {
    if (selectedScreen) {
      updateCustomConfig({
        ScreenSlotProps: {
          screen: 'screenAccess',
          updateValue: setSelectedScreen,
          initialValue: selectedScreen,
          screenOptions,
        },
        AdditionalHeaderComp: [{ name: 'headerScreenList', Component: HeaderScreenList }],
        SetColumnConfig: ScreenAccessColumnConfig,
        SetIsCellEditable,
        uniqueValidator: RoleFeatureValidator,
        CommitHandler,
      });
    }
  }, [selectedScreen, screenOptions]);

  return <GridTable tableRes={tableRes} />;
};

function SetIsCellEditable(props) {
  const { field, row, access } = props;
  let isEditable = true;
  if ((field === 'role_id' && row.status !== 'N')) {
    isEditable = false;
    return isEditable;
  }
  const rolePermission = access?.[field]?.accessLevel === 'U';
  return row.status !== 'D' && access?.edit_row && isEditable && rolePermission;
}

function RoleFeatureValidator(rows, row) {
  const result = {
    isValid: true,
    errors: {},
  };
  if (row['role_id']) {
    const filteredRow = rows.filter((item) => {
      return item.status !== 'N' && item.status !== 'E';
    });
    const newCheck = filteredRow.findIndex(
      (item) => item['role_id'] === row['role_id'] && item['access_level'] === row['access_level'],
    );
    if (newCheck >= 0) {
      result.isValid = false;
      result.errors['role_id'] = {
        field: 'role_id',
        msg: t('same_role_screen'),
      };
    }
  }
  return result;
}
